import {
  AllIconName,
  BreadcrumbsItem,
  Breadcrumbs as DSBreadcrumbs,
  EditableLabel,
  Icon,
  typography,
} from '@joor/design-system'
import { Link } from 'react-router-dom'
import styled from 'styled-components/macro'

export const StyledBreadcrumbsItem = styled(BreadcrumbsItem)`
  display: flex;
  align-items: center;
  ${typography.alpha.primaryActive.subtitle1}
`

export const OrderName = styled.div`
  ${typography.alpha.primaryActive.subtitle1}
  font-weight: var(--font-weight-semibold);
`

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: 5px;
  && {
    color: var(--color-secondary-800);
  }
`

export const StyledIcon = styled(Icon)`
  svg {
    --main-color: var(--color-secondary-800);
  }
`

type Props = {
  parents: { name: string; link: string; icon: AllIconName }[]
  current: { name: string; icon: AllIconName }
  onSubmit?: (value: string) => void
  onChange?: (value: string) => void
  isEditable?: boolean
}

export const Breadcrumbs = ({
  parents,
  current,
  onSubmit,
  onChange,
  isEditable,
}: Props) => (
  <DSBreadcrumbs>
    {parents.map(({ name, link, icon }, index) => (
      <StyledBreadcrumbsItem key={`${name}-${index}`}>
        <StyledLink to={link}>
          <StyledIcon iconName={icon} iconSize="small" plain />
          {name}
        </StyledLink>
      </StyledBreadcrumbsItem>
    ))}
    <StyledBreadcrumbsItem isCurrentPage>
      <EditableLabel
        disabled={!isEditable}
        onSubmit={(value) => onSubmit?.(value)}
        onChange={onChange}
        value={current.name}
      >
        <Icon
          className="icon-shopping-bag"
          iconName={current.icon}
          iconSize="small"
          plain
        />
        <OrderName>{current.name}</OrderName>
      </EditableLabel>
    </StyledBreadcrumbsItem>
  </DSBreadcrumbs>
)
